export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20flat%20lay%20photography%20featuring%20premium%20fashion%20products%20including%20cream%20white%20leather%20sneakers%20sage%20linen%20shirt%20folded%20camel%20wool%20coat%20and%20minimalist%20gold%20jewelry%20accessories%20arranged%20on%20light%20marble%20surface%20with%20scattered%20dried%20palm%20leaves%20natural%20sunlight%20streaming%20from%20large%20window%20creating%20soft%20highlights%20sophisticated%20neutral%20aesthetic%20warm%20earthy%20tones%20professional%20product%20styling&width=1800&height=1050&seq=kakobuy-hero-bg-v3-01&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska - nowoczesna baza produktów"
          title="Kakobuy Spreadsheet Polska 2026 – produkty, finds i linki"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            Kakobuy Spreadsheet Polska
          </h1>
          <p className="text-lg md:text-2xl text-background-50/90 mb-4 font-light">
            Najprostszy sposób na znalezienie najlepszych produktów i okazji
          </p>
          <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-2xl mx-auto leading-relaxed">
            Przeglądaj aktualizowaną bazę Kakobuy Spreadsheet, poznawaj popularne produkty, porównuj kategorie i korzystaj z kompletnych poradników zakupowych.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
            >
              <i className="ri-fire-line"></i>
              Kakobuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-950 rounded-full text-base font-semibold whitespace-nowrap hover:bg-background-100 transition-all duration-200"
            >
              <i className="ri-book-open-line"></i>
              Kup teraz
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {[
              { icon: 'ri-check-line', text: 'Niezależny przewodnik' },
              { icon: 'ri-refresh-line', text: 'Aktualizowane listy produktów' },
              { icon: 'ri-shield-check-line', text: 'Poradniki bezpieczeństwa' },
              { icon: 'ri-group-line', text: 'Polska społeczność' },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
                <i className={`${badge.icon} text-primary-400`}></i>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}